// extracted by mini-css-extract-plugin
module.exports = {"ImageWithPlaceHolder":"styles_ImageWithPlaceHolder__3-5N5","cover":"styles_cover__6uXFa"};